import { Link } from 'react-router-dom';
import { useLogout } from '../hooks/useLogout';
import { useAuthContext } from '../hooks/useAuthContext';
import { ReactComponent as MoneyLogo } from '../assets/wallet-logo.svg';
import { ReactComponent as UserLogo } from '../assets/account.svg';


import styles from './Navbar.module.css';

export default function Navbar() {

    const { logout } = useLogout();
    const { user } = useAuthContext();

    return (
        <nav className={styles.navbar}>
            <ul>
                <li className={styles.title}>
                    <span className={styles.icon}><MoneyLogo /></span>
                    myMoney
                </li>

                {!user && (
                    <>
                        <li><Link to="/login">Login</Link></li>
                        <li><Link to="/signup">Signup</Link></li>
                    </>
                )}

                {user && (
                    <>
                        <li className={styles.username}>
                            <span className={styles.icon}><UserLogo /></span>
                            <span>Hello, {user.displayName}</span>
                        </li>
                        <li>
                            <button className="btn" onClick={logout}>Logout</button>
                        </li>
                    </>
                )}
            </ul>
        </nav>
    )
}
